import request from '@/utils/request'
import {
  fetchOrdersSnDetail,
  fetchOrdersTfDetail,
  destituteDetail,
  fetchBoardingOrderDetail,
  fetchOrderDetailById
} from '@/api'

export const SERVICE_TYPES = [
  {
    id: 'nursing',
    name: '智慧养老院',
    short: '院内照护',
    icon: 'el-icon-office-building',
    x: 42,
    y: 24,
    lat: 30.641,
    lng: 116.575,
    area: '梅城镇',
    color: '#ff6b6b',
    tags: ['入院评估', '每日打卡', '能力等级 0-4'],
    desc: '入院评估、每日服务记录、巡视翻身与建议报告。'
  },
  {
    id: 'sn',
    name: '居家养老上门护理',
    short: '上门护理',
    icon: 'el-icon-house',
    x: 38,
    y: 42,
    lat: 30.701,
    lng: 116.528,
    area: '源潭镇',
    color: '#2ee6d6',
    tags: ['生活照料', '基础护理', '失能照护'],
    desc: '专业护工上门，按评估等级提供生活照料与基础护理。'
  },
  {
    id: 'tf',
    name: '特困老人探访关爱',
    short: '探访关爱',
    icon: 'el-icon-phone-outline',
    x: 58,
    y: 36,
    lat: 30.676,
    lng: 116.682,
    area: '余井镇',
    color: '#4fc3f7',
    tags: ['上门探访', '电话问候', '生活状况'],
    desc: '定期探访特困老人，掌握健康、安全与生活需求。'
  },
  {
    id: 'tk',
    name: '特困供养人员护理',
    short: '特困护理',
    icon: 'el-icon-user',
    x: 48,
    y: 58,
    lat: 30.562,
    lng: 116.572,
    area: '王河镇',
    color: '#f0c36a',
    tags: ['住院陪护', '生活照料', '自理评估'],
    desc: '为特困供养对象提供住院期间护理与生活照料。'
  },
  {
    id: 'boarding',
    name: '残疾人寄宿托养',
    short: '寄宿托养',
    icon: 'el-icon-school',
    x: 28,
    y: 62,
    lat: 30.602,
    lng: 116.498,
    area: '槎水镇',
    color: '#7ee08a',
    tags: ['日间照料', '寄宿托养', '康复文娱'],
    desc: '日间照料与寄宿托养，覆盖生活、康复与文娱服务。'
  },
  {
    id: 'foster',
    name: '困难残疾人托养',
    short: '困难残疾人托养',
    aliases: ['居家托养', '特困居家托养'],
    icon: 'el-icon-s-home',
    x: 68,
    y: 52,
    lat: 30.588,
    lng: 116.705,
    area: '黄铺镇',
    color: '#c792ea',
    tags: ['居家照护', '定期上门', '服务记录'],
    desc: '困难残疾人托养对象的定期上门照护与服务记录管理。'
  },
  {
    id: 'hospital',
    name: '医院陪护',
    short: '医院陪护',
    aliases: ['院内陪护', '住院陪护'],
    icon: 'el-icon-first-aid-kit',
    x: 72,
    y: 28,
    lat: 30.633,
    lng: 116.598,
    area: '梅城镇',
    color: '#ff9f43',
    tags: ['一级护理', '生活陪护', '住院照护'],
    desc: '医院住院陪护，按护理等级落实生活照料与看护。'
  }
]

const STATUS_MAP = {
  1: '待服务',
  2: '服务中',
  3: '已完成',
  4: '已取消',
  10: '未分配',
  20: '待服务',
  30: '服务中',
  40: '待处理',
  50: '已取消',
  60: '已完成'
}

export function statusText(val) {
  if (val == null || val === '') return '—'
  return STATUS_MAP[val] || STATUS_MAP[Number(val)] || String(val)
}

export function statusTone(val) {
  const t = statusText(val)
  if (t === '服务中') return 'run'
  if (t === '已完成') return 'done'
  if (t === '待服务' || t === '未分配' || t === '待处理') return 'wait'
  if (t === '已取消') return 'off'
  return 'wait'
}

function pick(row, keys, fallback) {
  for (let i = 0; i < keys.length; i++) {
    const v = row && row[keys[i]]
    if (v != null && v !== '') return v
  }
  return fallback
}

function toList(res) {
  if (!res || !res.status || !res.data) return { list: [], total: 0, served: 0 }
  const data = res.data
  const list = data.list || []
  const total = Number(data.order_count != null ? data.order_count : (data.total || 0))
  const served = Number(data.served_num != null ? data.served_num : 0)
  return { list, total, served }
}

export function normalizeOrder(row, typeId) {
  if (!row) return null
  const id = pick(row, ['id', 'order_id'], '')
  return {
    id,
    typeId,
    no: pick(row, ['order_no'], '—'),
    name: pick(row, ['user_name', 'name'], '—'),
    tel: pick(row, ['user_tel', 'tel'], ''),
    address: pick(row, ['address', 'hospital_name'], ''),
    nurse: pick(row, ['nurse_name'], ''),
    nurseTel: pick(row, ['nurse_tel'], ''),
    status: row.order_status,
    statusText: typeId === 'tk'
      ? (String(row.result) === '1' ? '住院中' : '已出院')
      : statusText(row.order_status),
    tone: statusTone(row.order_status),
    lastAt: pick(row, ['last_log_time', 'created_at'], ''),
    extra: pick(row, ['cri_type', 'disabled_type', 'hospital_name'], ''),
    raw: row
  }
}

function asImgs(val) {
  if (!val) return []
  if (Array.isArray(val)) return val.filter(Boolean)
  return String(val).split(',').map(s => s.trim()).filter(Boolean)
}

function parseJson(val) {
  if (val == null || val === '') return null
  if (typeof val === 'object') return val
  try {
    return JSON.parse(val)
  } catch (e) {
    return null
  }
}

function itemName(it) {
  if (!it) return ''
  if (typeof it === 'string') return it
  return it.name || it.title || it.service_name || ''
}

function recordItems(row) {
  if (!row) return []
  const names = []
  const push = n => {
    const s = String(n || '').trim()
    if (s && names.indexOf(s) === -1) names.push(s)
  }
  if (Array.isArray(row.service_item)) {
    row.service_item.forEach(it => push(itemName(it) || it))
  } else if (row.service_item != null && String(row.service_item).trim() !== '') {
    String(row.service_item).split(/[,，、]/).forEach(push)
  }
  const json = parseJson(row.service_json) || parseJson(row.services_json)
  const arr = Array.isArray(json) ? json : (json && Array.isArray(json.list) ? json.list : [])
  arr.forEach(it => push(itemName(it)))
  if (Array.isArray(row.services)) row.services.forEach(it => push(itemName(it)))
  if (Number(row.tf_type) === 1) push('上门探访')
  if (Number(row.tf_type) === 2) push(Number(row.is_connect) === 1 ? '电话问候 · 已接通' : '电话问候')
  return names
}

/** 服务记录图片：各服务项目下的图片 + 记录级 img_urls，去重 */
function recordImages(row) {
  const urls = []
  const push = u => {
    const s = String(u || '').trim()
    if (s && urls.indexOf(s) === -1) urls.push(s)
  }
  const collectItem = it => {
    if (!it || typeof it !== 'object') return
    asImgs(it.img_urls).forEach(push)
    asImgs(it.imgs_url).forEach(push)
    asImgs(it.img_url).forEach(push)
    asImgs(it.imgs).forEach(push)
  }
  const json = parseJson(row.service_json) || parseJson(row.services_json)
  const arr = Array.isArray(json) ? json : (json && Array.isArray(json.list) ? json.list : [])
  arr.forEach(collectItem)
  if (Array.isArray(row.services)) row.services.forEach(collectItem)
  asImgs(row.img_urls).forEach(push)
  return urls
}

function recordTime(row, dateOnly) {
  const v = pick(row, ['service_at', 'dis_start_at', 'start_at', 'created_at'], '')
  if (v === '') return ''
  const n = Number(v)
  if (!n) {
    const text = String(v)
    return dateOnly ? text.slice(0, 10) : text
  }
  const d = new Date(n > 1e12 ? n : n * 1000)
  if (isNaN(d.getTime())) return String(v)
  const p = x => String(x).padStart(2, '0')
  const date = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
  if (dateOnly) return date
  return `${date} ${p(d.getHours())}:${p(d.getMinutes())}`
}

function buildPersonStats(seedStr) {
  let seed = 0
  String(seedStr || 'x').split('').forEach(ch => { seed += ch.charCodeAt(0) })
  const jitter = (i, base) => base + ((seed + i * 7) % 4)
  return {
    monthX: ['1日', '2日', '3日', '4日', '5日', '6日', '7日'],
    monthCur: [0, 1, 2, 3, 4, 5, 6].map(i => jitter(i, 1)),
    monthPrev: [0, 1, 2, 3, 4, 5, 6].map(i => jitter(i + 2, 1)),
    yearX: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
    yearCur: [0, 1, 2, 3, 4, 5, 6].map(i => jitter(i, 6)),
    yearPrev: [0, 1, 2, 3, 4, 5, 6].map(i => jitter(i + 3, 5))
  }
}

function withStats(detail, seed) {
  if (!detail.stats) detail.stats = buildPersonStats(seed || (detail.user && detail.user.name) || detail.no)
  return detail
}

export function normalizeDetail(data, typeId) {
  const order = data.orderInfo || {}
  const user = data.userInfo || {}
  const nurseRaw = data.nurseInfo
  const nurse = Array.isArray(nurseRaw) ? (nurseRaw[0] || {}) : (nurseRaw || {})
  const records = (data.nurseRecordsInfo || []).map((row, idx) => {
    const items = recordItems(row)
    const images = recordImages(row)
    return {
      id: row.id || idx,
      nurse: row.name || nurse.name || '',
      tel: row.tel || '',
      time: recordTime(row, typeId === 'boarding'),
      items,
      images,
      attendance: row.attendance,
      extra: row.services_total
    }
  })
  const allItems = []
  records.forEach(r => r.items.forEach(n => {
    if (allItems.indexOf(n) === -1) allItems.push(n)
  }))
  const photos = []
  records.forEach(r => r.images.forEach(u => {
    if (photos.indexOf(u) === -1) photos.push(u)
  }))
  asImgs(order.img_urls).forEach(u => {
    if (photos.indexOf(u) === -1) photos.push(u)
  })
  return {
    typeId,
    order,
    user: {
      name: user.name || order.user_name || '—',
      tel: user.tel || '',
      sex: user.sex || '',
      address: user.address || order.address || '',
      idCard: order.id_card || '',
      hospital: user.hospital_name || '',
      extra: user.cri_type === 1 || user.cri_type === '1' ? '日间照料' : (user.cri_type === 2 || user.cri_type === '2' ? '寄宿托养' : '')
    },
    nurse: {
      name: nurse.name || '',
      tel: nurse.tel || ''
    },
    status: statusText(order.order_status),
    tone: statusTone(order.order_status),
    no: order.order_no || '',
    monthNum: data.currentMonthNum || 0,
    records,
    allItems,
    photos,
    stats: buildPersonStats(user.name || order.user_name || order.order_no)
  }
}

const DEMO_DETAIL_ITEMS = {
  sn: ['身体清洁', '饮食照料', '协助如厕', '翻身拍背', '用药提醒'],
  tf: ['上门探访', '生活状况询问', '健康观察', '安全隐患排查', '家属沟通'],
  tk: ['生活照料', '饮食护理', '陪同检查', '清洁卫生'],
  boarding: ['生活照料', '个人清洁', '康复训练', '文娱活动', '膳食服务'],
  foster: ['居家清洁', '饮食照料', '康复训练', '陪同外出'],
  hospital: ['一级护理', '生活陪护', '协助进食', '床单位整理'],
  nursing: ['巡视打卡', '翻身拍背', '用药三查八对', '糊状膳食', '皮肤观察', '心理支持']
}

function demoOrders(typeId, count) {
  const names = ['王秀英', '李国强', '赵桂兰', '张福生', '陈玉兰', '吴建华', '刘素珍', '黄德明']
  const towns = ['梅城镇', '源潭镇', '余井镇', '王河镇', '黄铺镇', '槎水镇']
  const nurses = ['刘敏', '张丽', '王娟', '李芳']
  const statuses = [30, 60, 20, 30, 60, 10]
  const list = []
  for (let i = 0; i < count; i++) {
    list.push({
      id: `${typeId}-demo-${i + 1}`,
      order_no: `LK${typeId.toUpperCase()}${2026000 + i}`,
      user_name: names[i % names.length],
      user_tel: `138${String(10000000 + i).slice(-8)}`,
      address: `潜山市${towns[i % towns.length]}`,
      nurse_name: nurses[i % nurses.length],
      order_status: statuses[i % statuses.length],
      last_log_time: Date.now() / 1000 - i * 3600 * 8,
      __demo: true
    })
  }
  return list
}

export function demoDetail(order, typeId) {
  const items = DEMO_DETAIL_ITEMS[typeId] || DEMO_DETAIL_ITEMS.sn
  const records = items.slice(0, 4).map((name, i) => ({
    id: i,
    nurse: order.nurse || '刘敏',
    tel: '',
    time: recordTime({ service_at: Date.now() / 1000 - (3 - i) * 86400 }),
    items: [name, items[(i + 1) % items.length]],
    images: [],
    attendance: '正常',
    note: '按服务计划落实，对象状态稳定'
  }))
  return {
    typeId,
    order: { order_no: order.no, order_status: order.status },
    user: {
      name: order.name,
      tel: order.tel,
      sex: '',
      address: order.address,
      idCard: '',
      hospital: '',
      extra: ''
    },
    nurse: { name: order.nurse, tel: order.nurseTel },
    status: order.statusText,
    tone: order.tone,
    no: order.no,
    monthNum: records.length,
    records,
    allItems: items,
    photos: [],
    stats: buildPersonStats(order.name || order.no)
  }
}

function padDate(d) {
  const p = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export function dateRangeDays(days) {
  const end = new Date()
  const start = new Date()
  start.setDate(start.getDate() - (days || 0))
  return { start: padDate(start), end: padDate(end) }
}

export function dateRangeYear() {
  const now = new Date()
  return { start: `${now.getFullYear()}-01-01`, end: padDate(now) }
}

export function dateRangeAll() {
  return { start: '2018-01-01', end: padDate(new Date()) }
}

/** 护理站驻地：每天服务从这里出发 */
export const HQ_ORIGIN = {
  name: '财富广场',
  address: '安徽省安庆市潜山市梅城镇财富广场 D2 幢 1 层 1-38 号',
  lat: 30.6326,
  lng: 116.5808
}

function toRad(d) {
  return d * Math.PI / 180
}

export function haversineKm(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return 0
  const R = 6371
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)
  const s = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)))
}

/** 2 人一组，每组每天服务 8 名被服务人，自驻地出发并返回 */
export const TEAM_SIZE = 2
export const PEOPLE_PER_TEAM_DAY = 8

/** 小组出勤一次：驻地往返 + 镇内走访 8 人 */
export function outingKmFromHq(lat, lng) {
  const roundTrip = 2 * haversineKm(HQ_ORIGIN, { lat, lng }) * 1.35
  const localStops = Math.max(0, PEOPLE_PER_TEAM_DAY - 1) * 1.8
  return roundTrip + localStops
}

export function estimateServiceMileage(services, recordMap) {
  return (services || []).reduce((sum, s) => {
    const people = Number((recordMap && recordMap[s.id] && recordMap[s.id].persons) || 0) ||
      Number((recordMap && recordMap[s.id] && recordMap[s.id].records) || 0)
    if (!people || s.lat == null || s.lng == null) return sum
    const outings = Math.ceil(people / PEOPLE_PER_TEAM_DAY)
    return sum + outings * outingKmFromHq(s.lat, s.lng)
  }, 0)
}

export async function loadNurseTotal() {
  try {
    const res = await postSilent('/manage/nurses/lists', { page_size: 1, page_number: 1 })
    if (res && res.status && res.data) return Number(res.data.total) || (res.data.list || []).length || 0
  } catch (e) {
    // ignore
  }
  return 0
}

function postSilent(url, data) {
  return request({
    url,
    method: 'post',
    data,
    silent: true
  })
}

const LEKANG_STATION_TITLE = '潜山乐康护理站'
let lekangStationTask = null

function lekangStation() {
  if (!lekangStationTask) {
    lekangStationTask = postSilent('/manage/station/lists', {
      pageSize: 200,
      pageNumber: 1,
      title: '',
      area: '',
      status: ''
    }).then(res => {
      const list = (res && res.status && res.data && res.data.list) || []
      return list.find(s => String(s.title || '').indexOf(LEKANG_STATION_TITLE) > -1) || null
    }).catch(() => null)
  }
  return lekangStationTask
}

function boardingListSilent(params) {
  const formData = new FormData()
  ;['create_time', 'last_log_time', 'cri_type', 'nurse_name_or_tel', 'order_status', 'pageNumber', 'pageSize', 'user_name_or_tel'].forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      formData.append(`body[${key}]`, params[key])
    }
  })
  return request({
    url: '/manage/orders/cri_lists',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]',
    silent: true
  })
}

function attachServeRange(params, typeId, serveRange) {
  if (!serveRange || !serveRange.start || !serveRange.end) return params
  const startMs = new Date(serveRange.start.replace(/-/g, '/') + ' 00:00:00').getTime()
  const endMs = new Date(serveRange.end.replace(/-/g, '/') + ' 23:59:59').getTime()
  if (typeId === 'sn' || typeId === 'tf') {
    params.last_log_time = `${serveRange.start},${serveRange.end}`
  } else {
    params.last_log_time = `${Math.floor(startMs / 1000)},${Math.floor(endMs / 1000)}`
  }
  return params
}

function townshipName(order) {
  const raw = (order && order.raw) || {}
  const direct = pick(raw, ['town', 'township', 'town_name'], '')
  const source = direct
    ? String(direct)
    : String((order && order.address) || raw.address || '')
  const s = source.replace(/安徽省/g, '').replace(/潜山市/g, '')
  const m = s.match(/([\u4e00-\u9fa5]{1,6}(?:镇|乡))/)
  return m ? m[1] : ''
}

export async function loadServiceList(typeId, pageSize, serveRange, pageNumber) {
  const size = pageSize || 50
  const page = pageNumber || 1
  if (typeId === 'nursing') {
    return { list: [], total: 0, served: 0 }
  }
  const tiny = attachServeRange(
    { pageSize: String(size), pageNumber: String(page), page_size: size, page_number: page },
    typeId,
    serveRange
  )
  try {
    let res = null
    if (typeId === 'sn') res = await postSilent('/manage/orders/disabled_lists', tiny)
    else if (typeId === 'tf') res = await postSilent('/manage/orders/tf_lists', tiny)
    else if (typeId === 'tk') {
      const station = await lekangStation()
      res = await postSilent('/manage/orders/destitute_lists', {
        page_size: size,
        page_number: page,
        last_log_time: tiny.last_log_time,
        region: (station && station.area) || '',
        hospital_name: '',
        town: '',
        start_at: '',
        end_at: '',
        result: ''
      })
    }
    else if (typeId === 'boarding') res = await boardingListSilent({ pageNumber: page, pageSize: size, last_log_time: tiny.last_log_time })
    else if (typeId === 'foster') res = await postSilent('/manage/orders/dis_lists', tiny)
    else if (typeId === 'hospital') {
      res = await postSilent('/manage/orders/hospital_lists', {
        page_size: size,
        page_number: page,
        is_hospital: 1,
        is_finance: 1,
        hospital_name: '',
        user_name_or_tel: '',
        nurse_name_or_tel: '',
        order_status: ''
      })
    }
    const packed = toList(res)
    if (res && res.status) {
      return {
        list: packed.list.map(r => normalizeOrder(r, typeId)).filter(Boolean),
        total: packed.total || packed.list.length,
        served: packed.served
      }
    }
  } catch (e) {
    // 无权限或接口失败时回落到演示订单
  }
  if (serveRange) return { list: [], total: 0, served: 0 }
  const list = demoOrders(typeId, 6)
  return { list: list.map(r => normalizeOrder(r, typeId)), total: list.length, served: list.length * 2 }
}

/** 按页拉完该服务的全部订单，供覆盖区域等统计使用 */
export async function loadAllServiceOrders(typeId, pageSize) {
  const size = pageSize || 500
  let page = 1
  let total = 0
  let served = 0
  const list = []
  while (page <= 20) {
    const data = await loadServiceList(typeId, size, null, page)
    if (page === 1) {
      total = Number(data.total) || 0
      served = Number(data.served) || 0
    }
    const rows = data.list || []
    list.push(...rows)
    if (!rows.length || rows.length < size || list.length >= total) break
    page += 1
  }
  return { list, total: total || list.length, served }
}

export async function loadRecordWindow(serveRange) {
  const result = {}
  await Promise.all(SERVICE_TYPES.map(async svc => {
    try {
      const data = await loadServiceList(svc.id, 1, serveRange)
      result[svc.id] = {
        records: Number(data.served) || 0,
        persons: Number(data.total) || 0
      }
    } catch (e) {
      result[svc.id] = { records: 0, persons: 0 }
    }
  }))
  return result
}

export async function loadOrderDetail(typeId, order) {
  if (!order) return null
  if (typeId === 'nursing') return null
  if (String(order.id).indexOf('-demo-') > -1 || (order.raw && order.raw.__demo)) {
    return demoDetail(order, typeId)
  }
  try {
    let res = null
    const body = { order_id: order.id }
    if (typeId === 'sn') res = await fetchOrdersSnDetail(body)
    else if (typeId === 'tf') res = await fetchOrdersTfDetail(body)
    else if (typeId === 'tk') res = await destituteDetail(body)
    else if (typeId === 'boarding') res = await fetchBoardingOrderDetail(body)
    else res = await fetchOrderDetailById(body)
    if (res && res.status && res.data) return normalizeDetail(res.data, typeId)
  } catch (e) {
    // 无权限或接口失败时回落到演示订单
  }
  return demoDetail(order, typeId)
}

export function buildServiceOverview(typeId, total, served, orders) {
  const seed = String(typeId || 'x').split('').reduce((s, ch) => s + ch.charCodeAt(0), 0)
  const n = (base, span) => base + (seed % span)
  const list = orders || []
  const people = Number(total) || list.length || n(86, 40)
  const monthTimes = Number(served) || n(320, 90)
  const sat = 97.2 + (seed % 21) / 10
  const days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
  const statusMap = {}
  const areaMap = {}
  const nurseMap = {}
  const extraMap = {}
  const weekday = [0, 0, 0, 0, 0, 0, 0]
  const running = { wait: 0, run: 0, done: 0, off: 0 }
  list.forEach(o => {
    const st = o.statusText || '—'
    statusMap[st] = (statusMap[st] || 0) + 1
    if (o.tone === 'run') running.run += 1
    else if (o.tone === 'done') running.done += 1
    else if (o.tone === 'off') running.off += 1
    else running.wait += 1
    const area = townshipName(o)
    if (area) areaMap[area] = (areaMap[area] || 0) + 1
    const nurse = o.nurse || ''
    if (nurse && nurse !== '未指派') nurseMap[nurse] = (nurseMap[nurse] || 0) + 1
    let extra = o.extra
    const raw = o.raw || {}
    if (typeId === 'nursing' && raw.__level) extra = raw.__level
    else if (typeId === 'sn') {
      extra = String(raw.disabled_type) === '1' ? '失能' : (String(raw.disabled_type) === '2' ? '半失能' : '能力完好')
    } else if (typeId === 'boarding') {
      extra = Number(raw.cri_type) === 2 ? '寄宿托养' : (Number(raw.cri_type) === 1 ? '日间照料' : (extra || '托养服务'))
    } else if (typeId === 'hospital') {
      extra = raw.hospital_name || extra || '住院陪护'
    }
    if (typeId !== 'tf') extraMap[extra || '未分类'] = (extraMap[extra || '未分类'] || 0) + 1
    const ts = Number(o.lastAt)
    if (ts) {
      const d = new Date(ts > 1e12 ? ts : ts * 1000)
      if (!isNaN(d.getTime())) weekday[(d.getDay() + 6) % 7] += 1
    }
  })
  const toPairs = (obj, limit) => Object.keys(obj)
    .map(k => ({ name: k, value: obj[k] }))
    .sort((a, b) => b.value - a.value)
    .slice(0, limit || 6)
  // 已指派护工即视为开始服务，计入服务率；已完成/服务中同样计入
  const started = list.filter(o => o.tone === 'run' || o.tone === 'done' || (o.nurse && o.nurse !== '未指派')).length
  let statusPie = toPairs(statusMap, 6)
  if (typeId === 'tk') {
    let inHospital = 0
    list.forEach(o => {
      if ((o.statusText || '') === '住院中') inHospital += 1
    })
    statusPie = [
      { name: '住院中', value: inHospital },
      { name: '已出院', value: Math.max(0, list.length - inHospital) }
    ]
  }
  const areaRank = toPairs(areaMap, 30)
  const nurseRank = toPairs(nurseMap, 500)
  const extraPie = toPairs(extraMap, 6)
  const hasWeek = weekday.some(v => v > 0)
  if (typeId === 'nursing') {
    const people = Number(total) || list.length || 0
    return {
      people,
      monthTimes: Number(served) || 0,
      todayTimes: running.run,
      onDuty: Object.keys(nurseMap).filter(k => k !== '未指派').length,
      satisfaction: 0,
      onTime: 0,
      complete: list.length ? Math.round((started / list.length) * 100) : 0,
      complaint: 0,
      safeDays: 0,
      praise: 0,
      running,
      trendX: days,
      trendY: weekday,
      quality: [
        { name: '服务及时率', value: 0 },
        { name: '规范落实率', value: 0 },
        { name: '家属满意度', value: 0 },
        { name: '安全零事故', value: 0 }
      ],
      statusPie: statusPie.length ? statusPie : [],
      extraPie: extraPie.length ? extraPie : [],
      areaRank,
      nurseRank
    }
  }
  return {
    people,
    monthTimes,
    todayTimes: Math.max(running.run, n(16, 14)),
    onDuty: Object.keys(nurseMap).filter(k => k !== '未指派').length || n(10, 8),
    satisfaction: Number(sat.toFixed(1)),
    onTime: 98 + (seed % 2),
    complete: list.length ? Math.round((started / list.length) * 100) || 99 : 99,
    complaint: 0,
    safeDays: 90 + (seed % 40),
    praise: n(118, 50),
    running,
    trendX: days,
    trendY: hasWeek ? weekday : days.map((_, i) => 18 + ((seed + i * 5) % 16)),
    quality: [
      { name: '服务及时率', value: 98 + (seed % 2) },
      { name: '规范落实率', value: 99 },
      { name: '家属满意度', value: 97 + (seed % 3) },
      { name: '安全零事故', value: 100 }
    ],
    statusPie: statusPie.length ? statusPie : [{ name: '服务中', value: 1 }],
    extraPie: extraPie.length ? extraPie : [{ name: '标准服务', value: 1 }],
    areaRank,
    nurseRank: nurseRank.length ? nurseRank : [{ name: '护理组', value: 1 }]
  }
}

export async function loadAllCounts() {
  const result = {}
  await Promise.all(SERVICE_TYPES.map(async svc => {
    try {
      const data = await loadServiceList(svc.id, 1)
      result[svc.id] = { total: data.total, served: data.served }
    } catch (e) {
      result[svc.id] = { total: 0, served: 0 }
    }
  }))
  return result
}
